import { CreditCostMarker } from "@/components/features/Credits/CreditCostMarker";
import { Button } from "@/design-system/Button/Button";
import { useTranslation } from "@repo/shared/i18n";

type Props = {
  loading: boolean;
  onClick: () => void;
  chemOptimizing?: boolean;
  disabled?: boolean;
  /** Whether this build would draw on the club, and so be charged. */
  usesClub?: boolean;
};

export const SuggestSquadsButton = ({
  loading,
  onClick,
  chemOptimizing,
  disabled,
  usesClub,
}: Props) => {
  const { t } = useTranslation("squadBuilder");
  return (
    <div className="relative inline-flex">
      <Button
        variant="primary"
        size="medium"
        disabled={loading || disabled}
        onClick={onClick}
      >
        {loading
          ? chemOptimizing
            ? t("build.chemOptimizing")
            : t("build.buildingSquads")
          : chemOptimizing
            ? t("build.chemOptimize")
            : t("build.buildSquads")}
      </Button>
      {/*
        Market-only builds are free, so the price follows the scope, and it is
        hidden while the build runs, when the choice has already been made.
        See CreditCostMarker for why this button is `relative` and the price
        sits outside it.
      */}
      {!loading && (
        <CreditCostMarker
          featureId="build-squad-club"
          when={usesClub}
          placement="beside-button"
        />
      )}
    </div>
  );
};
